import CouponsOverview from "@/models/storePanel/redeem/CouponsOverview";
import moment from "moment";

export default {
    namespaced: true,

    state: () => ({
        coupons: [],
        exportFile: null,
        redeemedCouponAndVoucherCodesData: [],
        itemsLength: 0
    }),

    mutations: {
        setItems(state, payload) {
            state.coupons = payload.map(c => {
                c.created_at = moment(c.created_at).format("DD/MM/YYYY HH:mm");
                if (c.available === null) c.available = "Unlimited";
                return c;
            });
        },

        setExportFile(state, payload){
            state.exportFile = payload
        },

        setRedeemedCouponAndVoucherCodes(state, payload){
            state.redeemedCouponAndVoucherCodesData = payload
        },

        setItemsLength(state, payload){
            state.itemsLength = payload
        }
    },

    actions: {
        async getItems({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await CouponsOverview.get(query);

                const {
                    data: coupons,
                    pagination
                } = data.data.redeemed_coupons;

                commit("setItems", coupons);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },

        async getRedeemedCouponAndVoucherCodes({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let query = `?page=${body.page}`
                if(body.search){
                    query += `&q=${body.search}`
                }
                if(body.order){
                    query += `&order=${body.order}`
                } 

                const { data } = await CouponsOverview.getRedeemedCouponAndVoucherCodes(body.coupon_id, query);

                const { redeemed_coupons_information, pagination } = data.data

                commit("setRedeemedCouponAndVoucherCodes", redeemed_coupons_information);
                commit("setItemsLength", pagination.total);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },

        async getExportedFileStatus({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await CouponsOverview.getExportedFileStatus()

                commit("setExportFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportCoupons({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await CouponsOverview.exportCoupons()

                commit("setExportFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await CouponsOverview.deleteExportedFile(id)

                commit("setExportFile", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        }
    }
};
